import { EventController } from './base';
import { dateTimePickerIcons } from '../helpers';
import ReactDOM from 'react-dom';
import AddEditLesson, {
  ModuleInstance,
  Supersource,
  FileInfo,
  SubsourceInfo,
  CarryoverModuleInstance,
} from '../components/AddEditLesson';
import React from 'react';

interface TeacherInfo {
  id: number;
}

export default class AddEditLessonController extends EventController {
  static targets = ['render', 'lessonStart', 'teacherSelect', 'missingStudyPeriodWarning'];

  renderTarget: HTMLElement;
  missingStudyPeriodWarningTarget: HTMLElement;
  lessonStartTarget: HTMLInputElement;
  teacherSelectTarget: HTMLSelectElement;
  studentId: string;

  connect() {
    this.studentId = JSON.parse(this.data.get('studentId'));
    const supersources: Supersource[] = JSON.parse(this.data.get('supersources'));
    const userFiles: FileInfo[] = JSON.parse(this.data.get('userFiles'));
    const regularTeachers = JSON.parse(this.data.get('regularTeachers'));
    this.resortTeacherSelect(regularTeachers);

    const defaultSupersourceId = supersources.find(supersource => supersource.name.toLowerCase().includes('allset'))?.id;

    const moduleInstances: ModuleInstance[] = JSON.parse(this.data.get('moduleInstances'));

    const defaultSubsourcesData: SubsourceInfo[] = JSON.parse(this.data.get('defaultSubsources'));
    const carryoverModuleInstances: CarryoverModuleInstance[] = JSON.parse(this.data.get('carryoverModuleInstances'));
    const isNew: boolean = JSON.parse(this.data.get('isNew'));

    if (isNew) {
      const lessonStartDate = $(this.lessonStartTarget).val() as string;
      this.checkStudyPeriod(lessonStartDate);
    }
    // use React to do most of the interactive rendering
    ReactDOM.render(React.createElement(AddEditLesson, {
      supersources,
      userFiles,
      isNew,
      carryoverModuleInstances,
      defaultSubsourcesData,
      moduleInstances,
      defaultSupersourceId,
      studentId: this.studentId,
    }), this.renderTarget);

    ($(this.lessonStartTarget) as any).datetimepicker({
      stepping: 15,
      extraFormats: ['YYYY.MM.DD HH.mm.ss'],
      icons: dateTimePickerIcons,
    }).on('dp.change', (evt: any) => {
      if (isNew) {
        $(this.missingStudyPeriodWarningTarget).toggle(false);
        this.checkStudyPeriod(evt.date.toISOString());
      }
    });
  }

  resortTeacherSelect(regularTeachers: TeacherInfo[]) {
    const regularTeacherIds = regularTeachers.map(teacher => teacher.id);
    const $teacherSelect = $(this.teacherSelectTarget);
    const selectedVal = $teacherSelect.val();
    const $options = $teacherSelect.find('option');
    const regularTeacherOptions: HTMLElement[] = [];
    const otherTeacherOptions: HTMLElement[] = [];
    $options.each((i, option) => {
      if (regularTeacherIds.indexOf(parseInt(option.value, 10)) >= 0) {
        regularTeacherOptions.push(option);
      } else {
        otherTeacherOptions.push(option);
      }
    });
    let sortedOptions: HTMLElement[] = [];
    sortedOptions = sortedOptions.concat(regularTeacherOptions);
    sortedOptions.push($('<option disabled>──────────</option>')[0]);
    sortedOptions = sortedOptions.concat(otherTeacherOptions);
    $teacherSelect.empty();
    sortedOptions.forEach((option) => {
      $teacherSelect.append(option);
    });
    $teacherSelect.val(selectedVal);
  }

  checkStudyPeriod(dateStr: string) {
    $.get(`/admin/api/student/${this.studentId}/check-study-period?lesson_date=${encodeURIComponent(dateStr)}`, (res) => {
      const studyPeriodId = res.study_period && res.study_period.id;
      $(this.missingStudyPeriodWarningTarget).toggle(!studyPeriodId);
    });
  }
}
